export class DB {
    Type: string = "DB";
    Data: string;
}